import { api } from "@/api";

import { QueryProps } from "@/types/Api";
import { Provider } from "@/types/ApiResponses/Provider";

export interface GetProvidersFilters {}

export const getProviders = async (
  props: QueryProps<GetProvidersFilters>
): Promise<Provider[]> => {
  const res = await api.client.get(`/providers-new`, {
    signal: props.signal,
    params: props.params,
  });
  return res.data;
};
